import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const locationService = {};

// Create Shipping Unit
locationService.createLocation = data => {
  return fetchV2({
    url: `${env.API_MSP}/locations`,
    method: "post",
    data: {
      ...data,
    },
  });
};
locationService.updateLocation = ({ id = undefined, data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/locations/${id}`,
    method: "put",
    data: data,
  });
};
locationService.deleteLocation = ({ id }) => {
  return fetchV2({
    url: `${env.API_MSP}/locations/${id}`,
    method: "delete",
  });
};
locationService.geListLocation = ({ params }) => {
  return fetchV2({
    url: `${env.API_MSP}/locations`,
    method: "get",
    params: {
      ...params,
      "filter[record_status]": "O",
    },
  });
};

export default locationService;
